jQuery(function ($) {
    // Carousel Posts/Custom
    if ($('.carousel-block')) {
        $('.carousel-block').each(function () {

            let slider = $(this).find('.ems-slick-container');
            let settings = JSON.parse(slider.attr('data-settings'));

            slider.slick({
                dots: settings.dots,
                arrows: settings.arrows,
                autoplay: settings.autoplay,
                autoplaySpeed: (settings.autoSpeed * 1000),
                speed: settings.animationpeed,
                prevArrow: '<button type="button" class="slick-prev"></button>',
                nextArrow: '<button type="button" class="slick-next"></button>',
                variableHeight: true,
            });
        });
    }


    // Carousel Images
    if ($('.carousel-images-block').length) {
        $('.carousel-images-block').each(function () {
            let img_slider = $(this).find('.ems-slick-container.primary-slider');
            let settings = JSON.parse(img_slider.attr('data-settings'));

            // console.log(settings);

            img_slider.slick({
                dots: settings.dots,
                arrows: settings.arrows,
                autoplay: settings.autoplay,
                autoplaySpeed: (settings.autoSpeed * 1000),
                speed: settings.animationpeed,
                prevArrow: '<button type="button" class="slick-prev"></button>',
                nextArrow: '<button type="button" class="slick-next"></button>',
                variableHeight: true,
                // asNavFor: thumbslider,
            });
            // console.log(settings);


            if (settings.thumbnails == true) {

                let thumbslider = $(this).find('.thumbnail-slider');
                // console.log(thumbslider);

                thumbslider.slick({
                    dots: false,
                    arrows: false,
                    asNavFor: img_slider,
                    focusOnSelect: true,
                    slidesToShow: settings.slidesToShow,
                    centerMode: true,
                    slidesToScroll: 1,
                    variableHeight: false,
                    infinte: true,
                    loop: true,
                });
                img_slider.slick('slickSetOption', { 'asNavFor': $(thumbslider) },
                    false);
            }
        });
    }


})